import React, { useCallback } from 'react';
import styled, { css } from 'styled-components/macro';

import { LinkWithSearchParams as Link } from 'components/base/Link/Link';
import { ItemType } from 'components/Header/CompareDropdown/CompareDropdown';

const activeStyle = ({ theme }: { theme: any }): any => css`
  background-color: ${theme.Sand};
  font-weight: 600;

  span {
    padding-left: ${theme.spacing.small};
  }

  &:hover,
  &:focus {
    background: white !important;
    span {
      transform: none !important;
    }
  }
`;

export const Label = styled('p')`
  padding-left: 1rem;
  color: ${({ theme }): string => theme.CasperGrey};
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 600;
`;

const StyledButton = styled('button')`
  ${({ isActive }: { isActive: any }): any => isActive && activeStyle};
  width: 100%;
  text-transform: capitalize;
`;

export const Button = StyledButton.withComponent(Link);

interface ISubDropdownList {
  isCountry: boolean;
  items: ItemType[];
  topicString: string;
}

const SubDropdownList: React.FC<ISubDropdownList> = (props) => {
  const { isCountry, items, topicString } = props;

  const getLink = useCallback(
    ({
      isCountry,
      item,
      topicString,
    }: {
      isCountry: boolean;
      item: ItemType;
      topicString: string;
    }) =>
      isCountry
        ? `/compare/all/country/entity/${item?.entityType}/${topicString}`
        : `/compare/all/entity/${item?.entityType}/${topicString}`,
    []
  );

  return (
    <>
      <li>
        <Label>{`Compare ${isCountry ? ' countries' : ''}`}</Label>
      </li>

      {items.map(
        (item: ItemType, index: number): JSX.Element => (
          <li key={`${item?.value}-${index}`}>
            <Button
              to={getLink({ isCountry, item, topicString })}
              preserveSearch
            >
              {item.label}
            </Button>
          </li>
        )
      )}
    </>
  );
};

export default SubDropdownList;
